var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"20px"},attrs:{"id":"blog"}},[_c('articles',[_c('banner')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }